// extracted by mini-css-extract-plugin
export var consentLink = "cookie-consent-module--consentLink--7eca6";
export var container = "cookie-consent-module--container--b80ab";
export var learnMoreLink = "cookie-consent-module--learnMoreLink--5ef84";
export var message = "cookie-consent-module--message--de4aa";